<template>
  <div class="navbar-new">
    <v-flex class="middle-items" hidden-sm-and-down>
      <v-btn color="#44517B" dark @click="$emit('new-transaction')" v-if="!admin && company_registered" data-testid="header-new-transaction-button">
        {{i18n('Nova Transação')}}
      </v-btn>
    </v-flex>
    <div class="right-items">
      <v-menu open-on-hover offset-y>
        <template v-slot:activator="{ on }">
          <div class="navbar-btn-menu" flat v-on="on">
            <div class="user-info">
              <div id="user-name">{{name}}</div>
              <div id="user-email">{{email}}</div>
            </div>
            <v-icon id="arrow-up" color="#27DABC">expand_less</v-icon>
          </div>
        </template>
        <v-list class="navbar-submenu" dark>
          <v-list-tile @click="$router.push('/register/company')" active-class="menu-active" :value="isSelected('/register/company')">
            <v-list-tile-action>
              <v-icon color="#27DABC">account_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{i18n('Cadastro')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="admin" @click="$router.push('/admin/partners')" active-class="menu-active" :value="isSelected('/admin/partners')">
            <v-list-tile-action>
              <v-icon color="#27DABC">badge</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{i18n('Parceiros')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="$router.push('/bank_accounts')" active-class="menu-active" :value="isSelected('/bank_accounts')">
            <v-list-tile-action>
              <v-icon color="#27DABC">account_balance</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{i18n('Canais Bancários')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <div class="icons" :style="isMobile ? 'margin-left: 0px;' : 'margin-left: 40px;'">
      <v-tooltip bottom v-if="!isMobile">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            v-bind="attrs"
            v-on="on" 
            icon @click="$emit('signout')">
            <v-icon color="#27DABC">exit_to_app</v-icon>
          </v-btn>
        </template>
        <span>{{i18n('Sair')}}</span>
      </v-tooltip>

      <v-btn class="hidden-md-and-up" icon @click="$emit('toggle-drawer')" >
        <v-icon color="#E3E7ED">menu</v-icon>
      </v-btn>
   </div>
 </div>
</div>
</template>

<script>
  export default {
    name: 'Navbar',
    props: {
      name: {
        type: String,
        default: ''
      },
      email: {
        type: String,
        default: ''
      },
      admin: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      isSelected(path) {
        return this.$route.path == path
      }
    },
    data() {
      return {
        isMobile: false,
        company_registered: false
      }
    },
    mounted() {
      this.$root.store.getCompany((company)=>{
        if (!company) {
          this.$router.push('/register/company')
          this.company_registered = false
        } else {
          this.company_registered = true
        }
      }, (error)=>{
      })

      this.isMobile = this.$vuetify.breakpoint.xs
    }
  }
</script>

<style>
.navbar-new {
  background-color: white;
  display: flex;
  padding-right: 70px;
  padding-top: 24px;
  padding-bottom: 20px;
  margin-bottom: 18px;
}

@media (max-width: 480px) {
  .navbar-new{
    padding-right: 0px;
  }
}

.navbar-new > .middle-items {
  flex: 3;
  display: flex;
  justify-content: center;
}
.navbar-new > .right-items {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.navbar-new .navbar-btn-menu {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-bottom: 4px;
}

.navbar-new .navbar-btn-menu #arrow-up {
  position: relative;
  top: 8px;
}

.navbar-new .user-info {
  margin-right: 12px;
}

.navbar-new .user-info #user-name {
  color: #44517B;
  font-family: 'Paralucent';
  font-weight: 500;
  font-size: 16px;
  text-transform: none !important;
}

.navbar-new .user-info #user-email {
  color: #858EA1;;
  font-family: 'Paralucent';
  font-weight: 500;
  font-size: 12px;
  text-transform: none !important;
}

.navbar-submenu {
  background-color: #06233B !important;
  top: 12px;
  border-radius: 8px;
}

.navbar-submenu > div {
  padding-left: 8px;
  padding-right: 6px;
  border-radius: 8px  ;
}

.navbar-new .right-items .icons {
  margin-left: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue